import { useId } from 'react';

import './referenced-indicator.scss';

type Props = {
  count: number;
  isLoading?: boolean;
  variant?: 'full' | 'compact';
};

function referencedLabel(count: number): string {
  return `Referenced (${count})`;
}

function ReferencedIndicator({
  count,
  isLoading = false,
  variant = 'full',
}: Props) {
  const hintId = useId();

  if (variant === 'compact') {
    return (
      <span
        className="referenced-indicator referenced-indicator--compact"
        aria-label={isLoading ? 'Loading references' : referencedLabel(count)}
        aria-describedby={isLoading ? undefined : hintId}
        tabIndex={0}
      >
        {isLoading ? (
          <span className="referenced-indicator__spinner" aria-hidden="true" />
        ) : (
          <>
            <span className="referenced-indicator__dot" aria-hidden="true" />
            <span className="referenced-indicator__count" aria-hidden="true">
              ({count})
            </span>
            <span
              id={hintId}
              className="referenced-indicator__hint"
              role="tooltip"
            >
              {referencedLabel(count)}
            </span>
          </>
        )}
      </span>
    );
  }

  return (
    <span className="referenced-indicator">
      {isLoading ? (
        <span className="referenced-indicator__spinner" aria-label="Loading" />
      ) : (
        <span className="referenced-indicator__dot" />
      )}
      Referenced{!isLoading && ` (${count})`}
    </span>
  );
}

export { ReferencedIndicator };
